import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../modules/commons/services/split-service.service";

export class TopNavMainComponent implements IController {

  resource: any;
  siteId: any;
  loading?: boolean;

  private breadcrumbs: any;
  private hiddenCrumbs: any;
  private isLongBreadcrumbs: any;
  private isFullScreen: any;
  private currentUser: any;
  private online: any;
  private parentToolbar: any;
  private logoUrl: any;
  private isBigScreen: any;

  /* @ngInject */
  constructor(private UserService, private $mdMedia, private $state, private $mdUtil,
              private splitService: SplitService, private $mdSidenav, private triBreadcrumbsService,
              private $window: IWindowService, private $timeout: ITimeoutService, private $element) {
    this.breadcrumbs = this.triBreadcrumbsService.breadcrumbs;
    this.hiddenCrumbs = this.triBreadcrumbsService.hiddenCrumbs;
  }

  $onInit() {
    this.isLongBreadcrumbs = false;
    this.isFullScreen = false;
    this.currentUser = this.UserService.getCurrentUser();
    this.online = true;
    this.parentToolbar = this.$mdUtil.getClosest(this.$element, 'MD-TOOLBAR');

    if (this.siteId) {
      this.logoUrl = this.splitService.getSiteLogoUrl();
    }

    this.$window.addEventListener("offline", () => {
      this.$timeout(() => {
        this.online = false;
      }, 0)
    }, false);

    this.$window.addEventListener("online", () => {
      this.$timeout(() => {
        this.online = true;
      }, 0)
    }, false);

  }

  $doCheck() {
    this.isBigScreen = this.$mdMedia('gt-sm');
    this.checkIsLongBreadcrumbs();
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  openSideNav(navID) {
    this.$mdUtil.debounce(() => {
      this.$mdSidenav(navID).toggle();
    }, 300)();
  }

  changeStateFromCrumb(crumb) {
    if (!_.isUndefined(crumb.state)) {
      this.$state.go(crumb.state, crumb.params);
    }
  }

  toggleNotificationsTab(tab) {
    this.openSideNav('notifications');
  }

  onSubMenuSelect() {
    this.parentToolbar.classList.remove('md-has-open-menu');
  }

  showAllCrumbs() {
    this.triBreadcrumbsService.showHiddenCrumbs();
  }

  // function toggleFullScreen() {
  //     ctrl.isFullScreen = !ctrl.isFullScreen;
  //     // more info here: https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
  //     var doc = $document[0];
  //     if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement ) {
  //         if (doc.documentElement.requestFullscreen) {
  //             doc.documentElement.requestFullscreen();
  //         } else if (doc.documentElement.msRequestFullscreen) {
  //             doc.documentElement.msRequestFullscreen();
  //         } else if (doc.documentElement.mozRequestFullScreen) {
  //             doc.documentElement.mozRequestFullScreen();
  //         } else if (doc.documentElement.webkitRequestFullscreen) {
  //             doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
  //         }
  //     } else {
  //         if (doc.exitFullscreen) {
  //             doc.exitFullscreen();
  //         } else if (doc.msExitFullscreen) {
  //             doc.msExitFullscreen();
  //         } else if (doc.mozCancelFullScreen) {
  //             doc.mozCancelFullScreen();
  //         } else if (doc.webkitExitFullscreen) {
  //             doc.webkitExitFullscreen();
  //         }
  //     }
  // }

  private checkIsLongBreadcrumbs() {
    this.isLongBreadcrumbs = _.find(this.breadcrumbs.crumbs, (b) => {
      return b.isHidden;
    });
  }


}

angular
  .module('bringoz.admin.commons')
  .component('topNavMain', {
    bindings: {
      resource: '<?',
      siteId: '<?',
      loading: '<?'
    },
    /* @ngInject */
    template: require('./top-nav-main.html').default,
    controller: TopNavMainComponent
  });
